<div
    id="telemetryPointsForm"
    [ngClass]="isEditMode ? 'editing' : isCreateMode ? 'creating' : 'viewing'"
    ngModelGroup="telemetryPointsForm_{{ index }}"
    data-automation="pointContainer"
>
    <mat-expansion-panel
        (opened)="expandPanel()"
        (closed)="panelOpenedState = false"
        togglePosition="before"
        class="expansion-panel telemetry-panel_{{ index }}"
        #telemetryPanel
    >
        <mat-expansion-panel-header
            class="panel-override"
            collapsedHeight="74px"
            expandedHeight="48px"
            data-automation="pointHeader"
        >
            <mat-panel-title class="point-title">
                <div data-automation="displayLabel">
                    <ng-container>
                        {{ displayLabel }}
                    </ng-container>
                </div>
                <div>
                    <i *ngIf="isViewMode && !isRetired" (click)="handleEdit($event)"
                        ><img
                            class="edit-icon"
                            id="edit_panel_{{ index }}"
                            src="../../../assets/svg/edit-new.svg"
                            alt=""
                    /></i>
                    <i *ngIf="isCreateMode || isEditMode" (click)="deletePoint($event, index)"
                        ><img
                            class="edit-icon"
                            data-index="{{ index }}"
                            id="delete_panel_{{ index }}"
                            src="../../../assets/svg/delete.svg"
                            alt=""
                    /></i>
                </div>
            </mat-panel-title>

            <mat-panel-description class="point-subtitle">
                {{ panelOpenedState ? '' : pointSourceId }}
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="panel-override">
            <div class="form-entry" *ngIf="isEditMode || isCreateMode">
                <multi-locale-input
                    #displayLabels="ngModel"
                    name="displayLabels"
                    [inputLabel]="nameLabel"
                    [locales]="localeConfig.supportedLocales"
                    [(ngModel)]="point.displayLabels"
                    (ngModelChange)="onInputUpdate()"
                    [displayLabelKey]="localeConfig.displayLabelKey"
                    [localeKey]="localeConfig.localeKey"
                    [defaultLocale]="localeConfig.defaultLocale"
                    [placeholderText]="namePlaceholder"
                    [required]="true"
                    [id]="getDisplayLabelsId()"
                    [maxLength]="500"
                    data-automation="telemetryPointName"
                >
                </multi-locale-input>
            </div>

            <div class="form-entry" *ngIf="isCreateMode || isEditMode">
                <multi-locale-input
                    name="descriptions"
                    [inputLabel]="descriptionLabel"
                    [locales]="localeConfig.supportedLocales"
                    [(ngModel)]="point.descriptions"
                    [displayLabelKey]="localeConfig.displayLabelKey"
                    [localeKey]="localeConfig.localeKey"
                    [defaultLocale]="localeConfig.defaultLocale"
                    [placeholderText]="descriptionPlaceholder"
                    [id]="getDescriptionLabelsId()"
                >
                </multi-locale-input>
            </div>

            <div class="form-entry" *ngIf="isViewMode">
                <mat-label class="info-title">{{ 'shared.create.description' | translate }}:</mat-label>
                <mat-label class="info-value" data-automation="description" *ngIf="point.description">
                    {{ point.description }}
                </mat-label>
                <mat-label class="info-value info-placeHolder" data-automation="description" *ngIf="!point.description">
                    {{ 'shared.view.placeholder.description' | translate }}
                </mat-label>
            </div>

            <div class="form-entry">
                <mat-form-field *ngIf="isCreateMode || isEditMode" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'telemetry_point.create.data_provider' | translate }}</mat-label>
                    <mat-select
                        id="dataProvider_{{index}}"
                        name="dataProvider_{{index}}"
                        #dataProvider="ngModel"
                        class="create-select"
                        [ngClass]="{ failure: dataProvider.invalid && (dataProvider.dirty || dataProvider.touched) }"
                        [(ngModel)]="point.dataProvider"
                        data-automation="dataProviderSelector"
                        appSelectValid
                        [class.loading-field]="loadingDataProviders"
                        required
                        (selectionChange)="handleDataProviderChange($event)"
                        placeholder="{{
                            isEditMode && getSelectedDataProviderLabel()
                                ? getSelectedDataProviderLabel()
                                : ('telemetry_point.create.placeholder.data_provider' | translate)
                        }}"
                    >
                        <mat-option
                            *ngFor="let provider of dataProviders"
                            [value]="provider.id"
                            id="dataProvider_{{index}}_{{ provider.id }}"
                            >{{ provider.displayLabel }}</mat-option
                        >
                    </mat-select>
                    <mat-error
                        *ngIf="dataProvider.invalid && (dataProvider.dirty || dataProvider.touched)"
                        class="alert alert-danger"
                    >
                        <mat-error *ngIf="dataProvider.errors.selectValid">
                            <span class="input-title"></span>
                            <span data-automation="alertRequired">
                                {{ 'registration.validation.required' | translate }}
                            </span>
                        </mat-error>
                    </mat-error>
                    <mat-hint *ngIf="loadingDataProviders" align="end">{{
                        'registration.loading' | translate
                    }}</mat-hint>
                    <mat-spinner *ngIf="loadingDataProviders" matSuffix diameter="23"></mat-spinner>
                </mat-form-field>
                <ng-container *ngIf="isViewMode">
                    <mat-label class="info-title">{{ 'telemetry_point.create.data_provider' | translate }}:</mat-label>
                    <mat-label class="info-value" data-automation="dataProvider">
                        {{ getSelectedDataProviderLabel() }}
                    </mat-label>
                </ng-container>
            </div>

            <div class="form-entry">
                <mat-form-field *ngIf="isCreateMode || isEditMode" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'telemetry_point.create.channel' | translate }}</mat-label>
                    <mat-select
                        id="telemetry-channel_{{ index }}"
                        name="telemetry-channel_{{ index }}"
                        #channel="ngModel"
                        class="create-select"
                        [ngClass]="{ failure: channel.invalid && (channel.dirty || channel.touched) }"
                        [(ngModel)]="point.deliveredChannelId"
                        data-automation="channelSelector"
                        (selectionChange)="onChannelChange($event)"
                        [class.loading-field]="loadingChannels"
                        appSelectValid
                        [compareWith]="channelCompare"
                        placeholder="{{ 'telemetry_point.create.placeholder.channel' | translate }}"
                        required
                    >
                       <mat-option>{{ 'telemetry_point.create.placeholder.channel' | translate }}</mat-option>
                        <mat-option
                            *ngFor="let channel of channels"
                            [value]="channel.id"
                            id="telemetry-channel_{{ channel.id }}"
                            [disabled]="checkExistingPointChannels(channel.id)"
                            >{{ channel.displayLabel }}</mat-option
                        >
                    </mat-select>
                    <mat-error *ngIf="channel.invalid && (channel.dirty || channel.touched)" class="alert alert-danger">
                        <mat-error *ngIf="channel.errors.selectValid">
                            <span class="input-title"></span>
                            <span data-automation="alertRequired">
                                {{ 'registration.validation.required' | translate }}
                            </span>
                        </mat-error>
                    </mat-error>
                    <mat-hint *ngIf="loadingChannels" align="end">{{ 'registration.loading' | translate }}</mat-hint>
                    <mat-spinner *ngIf="loadingChannels" matSuffix diameter="23"></mat-spinner>
                </mat-form-field>
                <ng-container *ngIf="isViewMode">
                    <mat-label class="info-title">{{ 'telemetry_point.create.channel' | translate }}:</mat-label>
                    <mat-label class="info-value" data-automation="channel">
                        {{ pointChannel }}
                    </mat-label>
                </ng-container>
            </div>

            <div class="form-entry">
                <mat-form-field *ngIf="isCreateMode || isEditMode" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'telemetry_point.create.reporting_interval' | translate }}</mat-label>
                    <mat-select
                        id="reportingInterval_{{ index }}"
                        name="reportingInterval_{{ index }}"
                        #reportingInterval="ngModel"
                        class="create-select"
                        [ngClass]="{
                            failure: reportingInterval.invalid && (reportingInterval.dirty || reportingInterval.touched)
                        }"
                        [(ngModel)]="point.reportingInterval"
                        data-automation="reportingIntervalSelector"
                        appSelectValid
                        [class.loading-field]="loadingReportingIntervals"
                        required
                        [compareWith]="reportingIntervalCompare"
                        placeholder="{{ 'telemetry_point.create.placeholder.reporting_interval' | translate }}"
                    >
                        <mat-option
                            *ngFor="let interval of reportingIntervals"
                            [value]="interval.durationInMilliseconds"
                            id="interval_{{ interval.id }}"
                            >{{ interval.displayLabel }}</mat-option
                        >
                    </mat-select>
                    <mat-error
                        *ngIf="reportingInterval.invalid && (reportingInterval.dirty || reportingInterval.touched)"
                        class="alert alert-danger"
                    >
                        <mat-error *ngIf="reportingInterval.errors.selectValid">
                            <span class="input-title"></span>
                            <span data-automation="alertRequired">
                                {{ 'registration.validation.required' | translate }}
                            </span>
                        </mat-error>
                    </mat-error>
                    <mat-hint *ngIf="loadingReportingIntervals" align="end">{{
                        'registration.loading' | translate
                    }}</mat-hint>
                    <mat-spinner *ngIf="loadingReportingIntervals" matSuffix diameter="23"></mat-spinner>
                </mat-form-field>
                <ng-container *ngIf="isViewMode">
                    <mat-label class="info-title"
                        >{{ 'telemetry_point.create.reporting_interval' | translate }}:</mat-label
                    >
                    <mat-label class="timezone-value info-value" data-automation="reportingInterval">
                        {{ getPointReportingInterval() }}
                    </mat-label>
                </ng-container>
            </div>

            <div class="form-entry">
                <mat-form-field *ngIf="isCreateMode || isEditMode" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'telemetry_point.create.source_id' | translate }}</mat-label>
                    <input
                        matInput
                        id="sourceId_{{ index }}"
                        #sourceId="ngModel"
                        type="text"
                        [ngClass]="{ failure: sourceId.invalid && (sourceId.dirty || sourceId.touched) }"
                        name="sourceId_{{ index }}"
                        placeholder="{{ 'telemetry_point.create.placeholder.source_id' | translate }}"
                        minlength="6"
                        maxlength="80"
                        pattern="[a-zA-Z0-9-_\s]+"
                        [(ngModel)]="point.sourceId"
                        (input)="onSourceIdChange($event)"
                        (paste)="onSourceIdPaste($event)"
                        (blur)="checkSourceId($event)"
                        data-automation="sourceId"
                        data-url-persist
                        required
                        appSourceValid
                    />
                    <mat-error
                        *ngIf="sourceId.invalid && (sourceId.dirty || sourceId.touched)"
                        class="alert alert-danger"
                    >
                        <mat-error *ngIf="sourceId.errors.required">
                            <span class="input-title"></span>
                            <span data-automation="alertRequired">
                                {{ 'registration.validation.required' | translate }}
                            </span>
                        </mat-error>
                        <mat-error *ngIf="sourceId.errors.pattern">
                            <span class="input-title"></span>
                            <span data-automation="patternError">{{
                                'registration.validation.pattern' | translate
                            }}</span>
                        </mat-error>
                        <mat-error *ngIf="sourceId.errors.sourceInvalid || sourceInvalid">
                            <span class="input-title"></span>
                            <span data-automation="sourceIDInvalid">
                                {{ 'registration.validation.sourceInvalid' | translate }}
                            </span>
                        </mat-error>
                        <mat-error *ngIf="sourceId.errors.minlength">
                            <span class="input-title"></span>
                            <span data-automation="lengthError">
                                {{ 'registration.validation.minLength' | translate }}
                            </span>
                        </mat-error>
                    </mat-error>
                </mat-form-field>
                <ng-container *ngIf="isViewMode">
                    <mat-label class="info-title">{{ 'telemetry_point.create.source_id' | translate }}:</mat-label>
                    <mat-label class="info-value" data-automation="sourceId">
                        {{ pointSourceId }}
                    </mat-label>
                </ng-container>
            </div>

            <!--Point ID-->
            <div class="form-entry" *ngIf="isEditMode || isViewMode" >
                <mat-form-field *ngIf="isEditMode" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'telemetry_point.create.point_id' | translate }}</mat-label>
                    <input
                            matInput
                            id="telemetry-pointId_{{ index }}"
                            type="text"
                            disabled
                            [matTooltip]="pointId"
                            name="telemetry-pointId_{{ index }}"
                            [(ngModel)]="point.id"
                            data-automation="pointId"
                            data-url-persist
                            appSourceValid
                    />
                </mat-form-field>
                <ng-container *ngIf="isViewMode">
                    <mat-label class="info-title">{{ 'telemetry_point.create.point_id' | translate }}:</mat-label>
                    <mat-label class="info-value" data-automation="pointId" [matTooltip]="pointId">
                        {{ pointId }}
                    </mat-label>
                </ng-container>
            </div>

            <div *ngIf="isCreateMode || isEditMode" class="form-entry form-entry-column">
                <div class="checkbox-wrapper">
                    <mat-checkbox
                        disabled="true"
                        id="veeBypass_{{ index }}"
                        #veeBypass="ngModel"
                        [ngClass]="{ failure: veeBypass.invalid && (veeBypass.dirty || veeBypass.touched) }"
                        name="veeBypass_{{ index }}"
                        [(ngModel)]="point.veeBypass"
                        data-automation="veeBypass"
                        data-url-persist
                        >{{ 'telemetry_point.create.set_vee_bypass' | translate }}</mat-checkbox
                    >
                    <mat-error
                        *ngIf="veeBypass.invalid && (veeBypass.dirty || veeBypass.touched)"
                        class="alert alert-danger"
                    >
                        <mat-error *ngIf="veeBypass.errors.required">
                            <span class="input-title"></span>
                            <span data-automation="alertRequired">
                                {{ 'registration.validation.required' | translate }}
                            </span>
                        </mat-error>
                    </mat-error>
                </div>
            </div>

            <div *ngIf="isViewMode" class="form-entry">
                <ng-container>
                    <mat-label class="info-title">{{ 'telemetry_point.create.set_vee_bypass' | translate }}:</mat-label>
                    <mat-label class="info-value" data-automation="veeBypass">
                        {{ point.veeBypass ? ('shared.true' | translate) : ('shared.false' | translate) }}
                    </mat-label>
                </ng-container>
            </div>
        </div>
    </mat-expansion-panel>
</div>
